module.exports = __webpack_public_path__ + "img/whatsapp.ceb641cc.svg";